var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFantasktic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 32,
    viewBox: "0 0 160 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0934 10.696C8.65344 10.696 7.56544 11.016 6.82944 11.656C6.09344 12.296 5.72544 13.24 5.72544 14.488V15.928H13.0454V18.568H5.72544V25H2.60544V14.488C2.60544 12.456 3.25344 10.864 4.54944 9.712C5.86144 8.544 7.66144 7.96 9.94944 7.96C10.9094 7.96 11.8054 8.064 12.6374 8.272C13.4694 8.48 14.1974 8.784 14.8214 9.184L13.8374 11.728C12.8454 11.04 11.5974 10.696 10.0934 10.696Z",
    fill: "url(#paint0_linear_720_3635)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8713 12.184V25H27.0153V23.344C26.5193 23.952 25.9033 24.408 25.1673 24.712C24.4473 25.016 23.6473 25.168 22.7673 25.168C21.5193 25.168 20.3993 24.896 19.4073 24.352C18.4313 23.808 17.6633 23.04 17.1033 22.048C16.5593 21.056 16.2873 19.904 16.2873 18.592C16.2873 17.28 16.5593 16.136 17.1033 15.16C17.6633 14.168 18.4313 13.4 19.4073 12.856C20.3993 12.312 21.5193 12.04 22.7673 12.04C23.5993 12.04 24.3593 12.184 25.0473 12.472C25.7513 12.76 26.3593 13.184 26.8713 13.744V12.184H29.8713ZM23.1033 22.6C24.2073 22.6 25.1193 22.232 25.8393 21.496C26.5593 20.76 26.9193 19.792 26.9193 18.592C26.9193 17.392 26.5593 16.424 25.8393 15.688C25.1193 14.952 24.2073 14.584 23.1033 14.584C21.9993 14.584 21.0873 14.952 20.3673 15.688C19.6633 16.424 19.3113 17.392 19.3113 18.592C19.3113 19.792 19.6633 20.76 20.3673 21.496C21.0873 22.232 21.9993 22.6 23.1033 22.6Z",
    fill: "url(#paint1_linear_720_3635)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0284 12.04C43.6444 12.04 44.9404 12.512 45.9164 13.456C46.8924 14.4 47.3804 15.8 47.3804 17.656V25H44.3804V18.04C44.3804 16.92 44.1164 16.08 43.5884 15.52C43.0604 14.944 42.3084 14.656 41.3324 14.656C40.2284 14.656 39.3564 14.992 38.7164 15.664C38.0764 16.32 37.7564 17.272 37.7564 18.52V25H34.7564V12.184H37.6124V13.84C38.1084 13.248 38.7324 12.8 39.4844 12.496C40.2364 12.192 41.0844 12.04 42.0284 12.04Z",
    fill: "url(#paint2_linear_720_3635)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3701 15.976C56.3701 16.696 56.2581 17.248 56.0341 17.632C55.8101 18 55.4501 18.264 54.9541 18.424C55.4501 18.584 55.8101 18.856 56.0341 19.24C56.2581 19.608 56.3701 20.152 56.3701 20.872V25.432C56.3701 26.024 56.5141 26.472 56.8021 26.776C57.1061 27.096 57.5541 27.256 58.1461 27.256H58.6501V29.656H57.4501C56.1061 29.656 55.0901 29.32 54.4021 28.648C53.7141 27.992 53.3701 27.024 53.3701 25.744V20.8C53.3701 20.032 53.0101 19.648 52.2901 19.648H51.4981V17.2H52.2901C53.0101 17.2 53.3701 16.816 53.3701 16.048V11.104C53.3701 9.824 53.7141 8.856 54.4021 8.2C55.0901 7.528 56.1061 7.192 57.4501 7.192H58.6501V9.592H58.1461C57.5541 9.592 57.1061 9.752 56.8021 10.072C56.5141 10.376 56.3701 10.824 56.3701 11.416V15.976Z",
    fill: "url(#paint3_linear_720_3635)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1889 24.304C68.8369 24.592 68.4049 24.808 67.8929 24.952C67.3969 25.096 66.8689 25.168 66.3089 25.168C64.9009 25.168 63.8129 24.8 63.0449 24.064C62.2769 23.328 61.8929 22.256 61.8929 20.848V9.352H64.8929V12.28H68.3249V14.68H64.8929V20.776C64.8929 21.4 65.0449 21.88 65.3489 22.216C65.6689 22.536 66.1089 22.696 66.6689 22.696C67.3409 22.696 67.9009 22.52 68.3489 22.168L69.1889 24.304Z",
    fill: "url(#paint4_linear_720_3635)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7348 12.184V25H81.8788V23.344C81.3828 23.952 80.7668 24.408 80.0308 24.712C79.3108 25.016 78.5108 25.168 77.6308 25.168C76.3828 25.168 75.2628 24.896 74.2708 24.352C73.2948 23.808 72.5268 23.04 71.9668 22.048C71.4228 21.056 71.1508 19.904 71.1508 18.592C71.1508 17.28 71.4228 16.136 71.9668 15.16C72.5268 14.168 73.2948 13.4 74.2708 12.856C75.2628 12.312 76.3828 12.04 77.6308 12.04C78.4628 12.04 79.2228 12.184 79.9108 12.472C80.6148 12.76 81.2228 13.184 81.7348 13.744V12.184H84.7348ZM77.9668 22.6C79.0708 22.6 79.9828 22.232 80.7028 21.496C81.4228 20.76 81.7828 19.792 81.7828 18.592C81.7828 17.392 81.4228 16.424 80.7028 15.688C79.9828 14.952 79.0708 14.584 77.9668 14.584C76.8628 14.584 75.9508 14.952 75.2308 15.688C74.5268 16.424 74.1748 17.392 74.1748 18.592C74.1748 19.792 74.5268 20.76 75.2308 21.496C75.9508 22.232 76.8628 22.6 77.9668 22.6Z",
    fill: "url(#paint5_linear_720_3635)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5799 25.168C92.5399 25.168 91.5239 25.032 90.5319 24.76C89.5399 24.488 88.7479 24.144 88.1559 23.728L89.3079 21.448C89.8839 21.832 90.5719 22.144 91.3719 22.384C92.1879 22.608 92.9879 22.72 93.7719 22.72C95.5639 22.72 96.4599 22.248 96.4599 21.304C96.4599 20.856 96.2279 20.544 95.7639 20.368C95.3159 20.192 94.5879 20.024 93.5799 19.864C92.5239 19.704 91.6599 19.52 90.9879 19.312C90.3319 19.104 89.7559 18.744 89.2599 18.232C88.7799 17.704 88.5399 16.976 88.5399 16.048C88.5399 14.832 89.0439 13.864 90.0519 13.144C91.0759 12.408 92.4519 12.04 94.1799 12.04C95.0599 12.04 95.9399 12.144 96.8199 12.352C97.6999 12.544 98.4199 12.808 98.9799 13.144L97.8279 15.424C96.7399 14.784 95.5159 14.464 94.1559 14.464C93.2759 14.464 92.6039 14.6 92.1399 14.872C91.6919 15.128 91.4679 15.472 91.4679 15.904C91.4679 16.384 91.7079 16.728 92.1879 16.936C92.6839 17.128 93.4439 17.312 94.4679 17.488C95.4919 17.648 96.3319 17.832 96.9879 18.04C97.6439 18.248 98.2039 18.6 98.6679 19.096C99.1479 19.592 99.3879 20.296 99.3879 21.208C99.3879 22.408 98.8679 23.368 97.8279 24.088C96.7879 24.808 95.3719 25.168 93.5799 25.168Z",
    fill: "url(#paint6_linear_720_3635)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.163 19.504L105.931 21.616V25H102.931V7.192H105.931V17.944L112.147 12.184H115.747L110.395 17.56L116.251 25H112.603L108.163 19.504Z",
    fill: "url(#paint7_linear_720_3635)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M124.765 17.2V19.648H123.949C123.613 19.648 123.349 19.744 123.157 19.936C122.981 20.128 122.893 20.416 122.893 20.8V25.744C122.893 27.024 122.541 27.992 121.837 28.648C121.149 29.32 120.133 29.656 118.789 29.656H117.589V27.256H118.093C118.701 27.256 119.149 27.096 119.437 26.776C119.741 26.472 119.893 26.024 119.893 25.432V20.872C119.893 20.136 119.997 19.584 120.205 19.216C120.429 18.848 120.789 18.584 121.285 18.424C120.789 18.264 120.429 18 120.205 17.632C119.997 17.264 119.893 16.712 119.893 15.976V11.416C119.893 10.824 119.741 10.376 119.437 10.072C119.149 9.752 118.701 9.592 118.093 9.592H117.589V7.192H118.789C120.133 7.192 121.149 7.528 121.837 8.2C122.541 8.856 122.893 9.824 122.893 11.104V16.048C122.893 16.432 122.981 16.72 123.157 16.912C123.349 17.104 123.613 17.2 123.949 17.2H124.765Z",
    fill: "url(#paint8_linear_720_3635)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.192 24.304C135.84 24.592 135.408 24.808 134.896 24.952C134.4 25.096 133.872 25.168 133.312 25.168C131.904 25.168 130.816 24.8 130.048 24.064C129.28 23.328 128.896 22.256 128.896 20.848V9.352H131.896V12.28H135.328V14.68H131.896V20.776C131.896 21.4 132.048 21.88 132.352 22.216C132.672 22.536 133.112 22.696 133.672 22.696C134.344 22.696 134.904 22.52 135.352 22.168L136.192 24.304Z",
    fill: "url(#paint9_linear_720_3635)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.632 12.184H142.632V25H139.632V12.184ZM141.144 10.072C140.6 10.072 140.144 9.904 139.776 9.568C139.408 9.216 139.224 8.784 139.224 8.272C139.224 7.76 139.408 7.336 139.776 7C140.144 6.648 140.6 6.472 141.144 6.472C141.688 6.472 142.144 6.64 142.512 6.976C142.88 7.296 143.064 7.704 143.064 8.2C143.064 8.728 142.88 9.176 142.512 9.544C142.16 9.896 141.704 10.072 141.144 10.072Z",
    fill: "url(#paint10_linear_720_3635)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M153.409 25.168C152.081 25.168 150.889 24.888 149.833 24.328C148.777 23.768 147.953 22.992 147.361 22C146.769 20.992 146.473 19.856 146.473 18.592C146.473 17.328 146.769 16.2 147.361 15.208C147.953 14.216 148.769 13.44 149.809 12.88C150.865 12.32 152.065 12.04 153.409 12.04C154.673 12.04 155.777 12.296 156.721 12.808C157.681 13.32 158.401 14.056 158.881 15.016L156.577 16.36C156.209 15.768 155.745 15.328 155.185 15.04C154.641 14.736 154.041 14.584 153.385 14.584C152.265 14.584 151.337 14.952 150.601 15.688C149.865 16.408 149.497 17.376 149.497 18.592C149.497 19.808 149.857 20.784 150.577 21.52C151.313 22.24 152.249 22.6 153.385 22.6C154.041 22.6 154.641 22.456 155.185 22.168C155.745 21.864 156.209 21.416 156.577 20.824L158.881 22.168C158.385 23.128 157.657 23.872 156.697 24.4C155.753 24.912 154.657 25.168 153.409 25.168Z",
    fill: "url(#paint11_linear_720_3635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_720_3635",
    x1: 158.881,
    y1: 6.472,
    x2: 151.537,
    y2: 53.1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2339FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFantasktic);
export default __webpack_public_path__ + "static/media/fantasktic.b6599d9801a0918794a6f16fb12fbf13.svg";
export { ForwardRef as ReactComponent };